// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      display: flex;
      flex-grow: 1;
    }
    .map-button {
      position: absolute; z-index: 9999;
      background: white;
      border-radius: 50px;
      width: 25px; height: 25px;
      padding: 5px;
    }
    .center {
      left: 50% !important;
      top: 50% !important;
    }
    .centered {
      transform: translate(-50%, -50%);
      left: 0 !important; top: 0 !important;
    }
    .button-text {
      background: white;
      padding: 5px;
      font-weight: bold;
      transform: translate(-50%, 20px);
      border-radius: 5px;
      text-transform: uppercase;
      font-size: 12px;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/components/device-map/devices-map.ts"],"names":[],"mappings":";IACI;MACE,aAAa;MACb,YAAY;IACd;IACA;MACE,kBAAkB,EAAE,aAAa;MACjC,iBAAiB;MACjB,mBAAmB;MACnB,WAAW,EAAE,YAAY;MACzB,YAAY;IACd;IACA;MACE,oBAAoB;MACpB,mBAAmB;IACrB;IACA;MACE,gCAAgC;MAChC,kBAAkB,EAAE,iBAAiB;IACvC;IACA;MACE,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;MACjB,gCAAgC;MAChC,kBAAkB;MAClB,yBAAyB;MACzB,eAAe;IACjB","sourcesContent":["\n    :host {\n      display: flex;\n      flex-grow: 1;\n    }\n    .map-button {\n      position: absolute; z-index: 9999;\n      background: white;\n      border-radius: 50px;\n      width: 25px; height: 25px;\n      padding: 5px;\n    }\n    .center {\n      left: 50% !important;\n      top: 50% !important;\n    }\n    .centered {\n      transform: translate(-50%, -50%);\n      left: 0 !important; top: 0 !important;\n    }\n    .button-text {\n      background: white;\n      padding: 5px;\n      font-weight: bold;\n      transform: translate(-50%, 20px);\n      border-radius: 5px;\n      text-transform: uppercase;\n      font-size: 12px;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
